import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild,OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { Province } from '@ascschool/model/category/province.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { BaocaoService } from '@ascschool/services/baocao/baocao.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { TypeOfEducationInvolveService } from '@ascschool/services/category/type-of-education-involve.service';
import { TypeOfSchoolService } from '@ascschool/services/category/typeofschool.service';
import { WardService } from '@ascschool/services/category/ward.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { Observable ,Subject} from 'rxjs';
import { map,takeUntil } from 'rxjs/operators';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { ModesOfEducationService } from '@ascschool/services/category/modese-of-education.service';
import { CapTrucThuocService } from '@ascschool/services/category/cap-truc-thuoc.service';
@Component({
  selector: 'app-csgd-tkcsgdtctt',
  templateUrl: './csgd-tkcsgdtctt.component.html',
  styleUrls: ['./csgd-tkcsgdtctt.component.scss']
})
export class BcCsgdTkcsgdtcttComponent implements OnInit,OnDestroy {
  constructor(
    private cdRef: ChangeDetectorRef, public _authService: AuthService, public sizePageService: SizePageService,
    private authQuery: AuthQuery, public utilService: UtilsService, private service: BaocaoService,
    private cttService: CapTrucThuocService, private caDisTypeOfEducationInvolvesService: TypeOfEducationInvolveService,
    private disProvincesService: ProvinceService, private districtService: DistrictService,
    private wardService: WardService, private disTypeOfSchoolsService: TypeOfSchoolService,
    private modesOfEducationService: ModesOfEducationService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
   }
  get breadcrumbs(): string[] {
    return ['Báo cáo về cơ sở giáo dục'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content(content: ElementRef) {
    if (content) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content;
    }
  }
  @ViewChild('pageHeaderTable2', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable2 = content2;
    }
  }
  @ViewChild('pageHeaderTable3', { static: false }) set content3(content3: ElementRef) {
    if (content3) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable3 = content3;
    }
  }
  $unSubscribe= new Subject();
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm = '';
  province = new Province();
  loading = true;
  Total = 0;
  thongtinCSGDList: any;
  ListCapHoc: any[] = [];
  ListLoaiHinh: any[] = [];
  ListDieuKien: any[] = [];
  pageSizeOptions: number[] = [50, 100, 200];
  pageIndex: number = 1;
  pageSize: number = this.pageSizeOptions[0];
  firstRowOnPage: any;
  dataList: any;
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef;
  private elementPageHeaderTable2: ElementRef;
  private elementPageHeaderTable3: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  @ViewChild('Table', { static: false }) tableElement: NzTableComponent;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation = 50;
  isCollapse = true;
  year = '';
  currentUser: any;
  getProvinceACFn: (value: any) => Observable<any>;  ProvinceSubscription: any;  ProvinceControl = new FormControl();
  getModesOfEducation: (value: any) => Observable<any>; ModesOfEducationSubscription: any; ModesOfEducationControl = new FormControl();
  getTypeOfEducationIdACFn: (value: any) => Observable<any>; TypeOfEducationIdSubscription: any; TypeOfEducationIdControl = new FormControl();
  getDisTypeOfSchoolsACFn: (value: any) => Observable<any>; disTypeOfSchoolsSubscription: any; disTypeOfSchoolsControl = new FormControl();
  getCaDisTypeOfEducationInvolvesACFn: (value: any) => Observable<any>; caDisTypeOfEducationInvolvesSubscription: any; caDisTypeOfEducationInvolvesControl = new FormControl();
  getCaDisNeedOfDisabilitysACFn: (value: any) => Observable<any>; caDisNeedOfDisabilitysSubscription: any; caDisNeedOfDisabilitysControl = new FormControl();
  getDisProvincesACFn: (value: any) => Observable<any>; DisProvincesSubscription: any; DisProvincesControl = new FormControl();
  getDistrictACFn: (value: any) => Observable<any>; DistrictSubscription: any; DistrictControl = new FormControl();
  getDisWardACFn: (value: any) => Observable<any>; DisWardSubscription: any; DisWardControl = new FormControl();
  getLivingConditionsACFn: (value: any) => Observable<any>; LivingConditionSubscription: any; LivingConditionControl = new FormControl();
  dataTable: any = [];
  dataHeader1: any = [];
  dataHeader2: any = [];
  dataHeader3: any = [];
  keyIdArr: any = [];
  isDisabled : boolean = false;
  isDisabled1 : boolean = false;
  isDisabled2 : boolean = false;
  sortNameFn = (a: Province, b: Province) => a.provinceName.localeCompare(b.provinceName);
  ngOnInit() {
    if(this.currentUser.accountType === 3){
      this.isDisabled = true;
    }else if(this.currentUser.accountType === 1){
      this.isDisabled1 = true;
    }else if(this.currentUser.accountType === 2){
      this.isDisabled2 = true;
    }
    if (this.currentUser.accountType === 3) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });

        //Quận huyện
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        }
      });

      //get quận huyện
      this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
        this.DistrictControl.setValue({ ProvinceId: this.currentUser.provinceId, id: response.id, text: response.districtName });
      });
    }
    if (this.currentUser.accountType === 1) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });

        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        }
      });
    }
    if (this.currentUser.accountType === 1) {
      this.commonFilter.subordinateTypeId = this.currentUser.eadId;
    } else {
      this.commonFilter.subordinateTypeId = 0;
    }
    if (this.currentUser.accountType === 2) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        }
        this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
          this.DistrictControl.setValue({ id: response.id, text: this.currentUser.eadName });
          this.reload();
        });
      });
    }

    this.reload();
    this.loadModesOfEducation();
    this.loadTypeOfEducationId();
    this.loadDisTypeOfSchools();
    this.loadDisProvinces();
    this.maxHeight = window.innerHeight;
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
    this.commonFilter.year = this.year;
  }
  changeYear() {
    this.commonFilter.year = this.year;
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  reload() {
    const _this = this;
    this.loading = true;
    _this.dataTable = [];
    _this.dataHeader1 = [];
    _this.dataHeader2 = [];
    _this.dataHeader3 = [];
    this.resetData();
    this.commonFilter.year = this.year;
    this.service.getRpCsgdTkcsgdCtt(this.commonFilter)
    .pipe(takeUntil(this.$unSubscribe)).subscribe(
      (response: any) => {
        if (response.data === null && response.pivotPtgd === null) {
          _this.dataTable = [];
        } else {
          this.resetData();
          this.handlingData(response);
          this.dataTable = response.data;
          this.width = 210 + (100 * this.keyIdArr.length);
        }
        _this.loading = false;
      }, (err: any) => {
        _this.dataTable = [];
        _this.loading = false;
      }
    );
  }
  handlingData(response?: any) {
    /*dataHeaderRow1 - du lieu header 1*/
    const sl_Lh = response.pivotLh.length;
    if (response.pivotCtt != null && response.pivotLh != null) {
      response.pivotCtt.forEach(ph => {
        this.dataHeader1.push({ 'rowSpan': 1, 'colSpan': (sl_Lh*2), 'dataName': ph.dataName });
        /* Xu ly lh */
        response.pivotLh.forEach(lh => {
          this.keyIdArr.push(ph.dataId + lh.dataId);
          this.dataHeader2.push({'rowSpan': 1, 'colSpan': sl_Lh, 'dataName': lh.dataName });
        });
      });

    }
  }

  exportExcel() {
    this.commonFilter.year = this.year;
    this.service.exportRpCsgdTkcsgdCtt(this.commonFilter).subscribe((data : any) => {
      const downloadURL = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'ThongKeCsgdTheoCapTrucThuoc.xlsx';
      link.click();
    });
  }
  search() {
    this.reload();
  }
  resetData() {
    this.dataTable = [];
    this.keyIdArr = [];
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.checkCaculateSize();
    }, 500);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'], label: 'Help', description: 'Cmd + b', command: (e) => console.log('alt + n'), preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateSize() {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = 210 + (100 * this.keyIdArr.length);
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.elementPageHeaderTable2,
      this.elementPageHeaderTable3,
      this.heightPagnagation
    );
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.checkCaculateSize();
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateSize();
    // this.height = 100;
  }
  loadDisTypeOfSchools() {
    // tslint:disable-next-line: max-line-length
    this.getDisTypeOfSchoolsACFn = (value: any) => this.disTypeOfSchoolsService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.typeOfSchoolName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.disTypeOfSchoolsSubscription) {
      this.disTypeOfSchoolsSubscription = this.disTypeOfSchoolsControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'TypeOfSchoolsId', this.disTypeOfSchoolsControl.value);
      });
    }
  }
  changeDisTypeOfSchools(control: FormControl) {
    this.disTypeOfSchoolsControl = control;
  }
  loadModesOfEducation() {
    // tslint:disable-next-line: max-line-length
    this.getModesOfEducation = (value: any) => this.modesOfEducationService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.ModesOfEducationSubscription) {
      this.ModesOfEducationSubscription = this.ModesOfEducationControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'modesOfEducationId', this.ModesOfEducationControl.value);
      });
    }
  }
  changeModesOfEducation(control: FormControl) {
    this.ModesOfEducationControl = control;
  }
  loadTypeOfEducationId() {
    // tslint:disable-next-line: max-line-length
    this.getTypeOfEducationIdACFn = (value: any) => this.cttService.getCapTrucThuocSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.TypeOfEducationIdSubscription) {
      this.TypeOfEducationIdSubscription = this.TypeOfEducationIdControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'TypeOfEducationId', this.TypeOfEducationIdControl.value);
      });
    }
  }
  changeTypeOfEducationId(control: FormControl) {
    this.TypeOfEducationIdControl = control;
  }
  loadCaDisTypeOfEducationInvolves() {
    // tslint:disable-next-line: max-line-length
    this.getCaDisTypeOfEducationInvolvesACFn = (value: any) => this.caDisTypeOfEducationInvolvesService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.caDisTypeOfEducationInvolvesSubscription) {
      this.caDisTypeOfEducationInvolvesSubscription = this.caDisTypeOfEducationInvolvesControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'SchoolLevelId', this.caDisTypeOfEducationInvolvesControl.value);
      });
    }
  }
  changeCaDisTypeOfEducationInvolves(control: FormControl) {
    this.caDisTypeOfEducationInvolvesControl = control;
  }

  // tslint:disable-next-line: adjacent-overload-signatures
  loadDisProvinces() {
    // tslint:disable-next-line: max-line-length
    this.getDisProvincesACFn = (value: any) => this.disProvincesService.getProvinceSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DisProvincesSubscription) {
      this.DisProvincesSubscription = this.DisProvincesControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.DisProvincesControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisProvincesACFn(control: FormControl) {
    this.DisProvincesControl = control;
    if (this.DisProvincesControl) {
      this.loadDistrict();
      this.DistrictControl.setValue(null);
    }
  }
  loadDistrict() {
    // tslint:disable-next-line: max-line-length
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
      searchTerm: value, ProvinceId: this.valueIfHas(this.DisProvincesControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DistrictSubscription) {
      this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDistrictACFn(control: FormControl) {
    this.DistrictControl = control;
    if (this.DistrictControl) {
      this.loadDisWard();
      this.DisWardControl.setValue(null);
    }
  }
  loadDisWard() {
    // tslint:disable-next-line: max-line-length
    this.getDisWardACFn = (value: any) => this.wardService.getWardSelectPaging({
      searchTerm: value, DistrictId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.wardName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DisWardSubscription) {
      this.DisWardSubscription = this.DisWardControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'WardId', this.DisWardControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisWardACFn(control: FormControl) {
    this.DisWardControl = control;
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value !== 'string') { return control.value.id; }
    return '';
  }
  clear() {
    this.year = '';
    if(this.currentUser.accountType === 6 || this.currentUser.accountType === 5){
      this.DisProvincesControl.setValue(null);
    }if(this.currentUser.accountType === 6 || this.currentUser.accountType === 5 || this.currentUser.accountType === 1){
      this.DistrictControl.setValue(null);
    }
    this.DisWardControl.setValue(null);
    this.TypeOfEducationIdControl.setValue(null);
    this.reload();
  }
  ngOnDestroy(): void {
    this.$unSubscribe.next();
    this.$unSubscribe.complete();
}
}
